export enum PaymentType {
    ARMY_MORTGAGE = 'ARMY_MORTGAGE',
    INSTALLMENT = 'INSTALLMENT',
    MOTHER_CAPITAL = 'MOTHER_CAPITAL'
}
